<template>
<div>
   <vuestic-widget>
         <div v-if="table.load">
            <div class="col-sm-12 col-lg-12 col-xl-12 d-flex justify-content-center">
            <div class="btn-toolbar d-inline-flex" role="toolbar" aria-label="Toolbar with button groups">
            <component :animation-duration="1000" :is="'SpringSpinner'" :color="'#4AE387'" :size="80"></component>
          </div>
        </div>
      </div>
           <div v-else class="col-12  justify-content-center">
              <h4 class="text-center">AULAS DO(A) {{this.nomeInstrutor}}</h4><br>
            <table class="table table-striped large-table table-hover">
              <thead>
                <tr>
                  <th>Agrupamento</th>
                  <th>Titulo</th>
                  <th>Virtual</th>
                  <th>Inicio Da Aula</th>
                  <th>Fim Da Aula</th>
                  <th>Ações</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="dados in table.data" :key="dados.id">
			        		<td>{{ dados.id_agrupamento }}</td>
                  <td>{{dados.titulo}}</td>
                  <td>{{dados.virtual ? 'VIRTUAL' : 'PRESENCIAL'}}</td>
					        <td>{{ utils.formatDate(dados.data_inicio) }}</td>
					        <td>{{ utils.formatDate(dados.data_fim) }}</td>
              <td class="td-turma">
                 <button title="Ver informações da turma" class="btn btn-primary btn-with-icon rounded-icon btn-micro ml-1" style="color: #1D2E5A;" @click="detalhes(dados.id_turma_teorica)">
				          <span aria-hidden="true" class="fa fa-info" style="font-size: 20px;padding-left: 3px;"></span>
				        </button>
                <button :id="'presenca_' + dados.id_agrupamento" title="Registrar Presença e ir pra Sala!" class="btn btn-primary btn-with-icon rounded-icon btn-micro presenca ml-2 mr-2" @click="registrarPresenca(dados)">
					        <span aria-hidden="true" class="fa fa-video-camera" style="font-size: 20px;padding-left: 3px; color: #1D2E5A;"></span>
				        </button>
                <button :id="'push_' + dados.id_agrupamento" v-if="getTime(dados.data_fim)"
                 title="Entrar na Sala de Aula" class="btn btn-primary btn-with-icon rounded-icon btn-micro mr-2" v-show="disabled" @click="push(dados)">
					        <span aria-hidden="true" class="fa fa-video-camera" style="font-size: 20px;padding-left: 3px; color: #1D2E5A;"></span>
				        </button>
              </td>
						</tr>
            <tr v-show="table.data.length === 0">
					   	<td colspan="8" class="text-center">Nenhuma aula encontrada.</td>
					  </tr>
              </tbody>

            </table>
          </div>
</vuestic-widget>

	<vuestic-modal id="modal-photo" ref="photoModal" :cancelClass="'none'" :okClass="'none'" v-on:cancel="modalClosed">
			<div class="col-sm-12 col-lg-12 col-xl-12">
				<div class="row justify-content-center text-center">
					<h1>Registre sua presença!</h1>
					<div class="col-md-6">
						<!-- <img id="mask" height="250" width="250" src="~assets/mask.png" /> -->
						<video id="player" width="250" height="250" autoplay ></video>
						<button @click="captureSnapshot" id="capture" class="btn btn-primary">Capturar</button>
					</div>
					<div class="col-md-6">
						<canvas id="snapshot" width="250" height="250"></canvas>
						<button @click="sendSnapshot" id="send" class="btn btn-primary" disabled>Enviar</button>
					</div>
				</div>
			</div>
		</vuestic-modal>

    	<!-- #Início# Modal de informações-->
							<vuestic-modal :show.sync="modal.show" ref='smallModal' v-bind:small="false" :cancelClass="'none'" okText="Fechar" cancelText="Fechar" :large="true">
								<div slot="title">Informações Sobre o Agrupamento</div>
								<div v-show="modal.load">
									<div class="col-sm-12 col-lg-12 col-xl-12 d-flex justify-content-center">
										<div class="btn-toolbar d-inline-flex" role="toolbar" aria-label="Toolbar with button groups">
											<component :animation-duration="1000" :is="'SpringSpinner'" :color="'#4AE387'" :size="80"></component>
										</div>
									</div>
								</div>
								<div v-show="!modal.load">
									<vuestic-tabs @change="ativar($event)" :names="['Dados Básicos','Alunos Regulares', 'Alunos Reposição', 'Aulas', 'Presenças']" ref="tabs">
										<div slot="Dados Básicos">
											<div class="row">
												<div class="col-md-4">
													<strong class="font-weight-bold">Agrupamento:</strong>
													<p>{{modal.conteudo.id_agrupamento}}</p>
												</div>
												<div class="col-md-4">
													<strong class="font-weight-bold">Data de inicio:</strong>
													<p>{{ utils.formatDate(modal.conteudo.data_inicio) }}</p>
												</div>
												<div class="col-md-4">
													<strong class="font-weight-bold">Data de finalização:</strong>
													<p>{{ utils.formatDate(modal.conteudo.data_fim) }}</p>
												</div>
											</div>
											<br>
										</div>
										<div slot="Alunos Regulares" v-if="regular === true">
											<div class="row">
												<div class="col-md-12">
													<TableAlunosTurma :idTurma="modal.conteudo.id_turma_teorica"></TableAlunosTurma>
												</div>
											</div>
											<br>
											<br>
										</div>
										<div slot="Alunos Reposição" v-if="reposicao === true">
											<div class="row">
												<div class="col-md-12" >
													<TableAlunosReposicao :idTurma="modal.conteudo.id_turma_teorica"></TableAlunosReposicao>
												</div>
											</div>
										</div>
										<div slot="Aulas">
											<div class="row">
												<div class="col-md-12" v-if="aula === true">
													<TableAulasTurma :idTurma="modal.conteudo.id_turma_teorica"></TableAulasTurma>
												</div>
											</div>
										</div>
										<div slot="Presenças">
											<div class="row">
												<div class="col-md-12" v-if="historico === true">
													<TablePresencas :idTurma="modal.conteudo.id_turma_teorica" :virtual="modal.conteudo.virtual" :idRole="id_role"></TablePresencas>
												</div>
											</div>
										</div>
									</vuestic-tabs>
								</div>
							</vuestic-modal>
							<!-- #Fim# Modal de informações-->

</div>
</template>

<script>

import urlApi from '../../router/urlApi';
import utils from '../../services/utils';
import * as spinners from 'epic-spinners';
import PresencaController from '../presenca/PresencaController';
import TurmasController from '../turmas/TurmasController';
import TableAlunosTurma from '../turmas/TableAlunosTurma.vue'
import TableAlunosReposicao from '../turmas/TableAlunosReposicao'
import TablePresencas from '../turmas/TablePresencas'
import TableAulasTurma from '../turmas/TableAulasTurma';
import router from '../../router';


export default {
    name: 'DashInstrutores',
    components: {
    ...spinners,
    TablePresencas,
    TableAulasTurma,
    TableAlunosReposicao,
    TableAlunosTurma,


  },
    data() {
      return {
        schema: localStorage.schema,
        idInstrutor: localStorage.id,
        nomeInstrutor: localStorage.nome,
        id_role: localStorage.id_role,
        instrutores: [],
        instrutor: '',
        utils: utils,
        table: { load: true },
        modal: {
        show: false,
        load: false,
        conteudo: {},
        },
        responseData: '',
        stream: null,
        isMobile: false,
        'historico': false,
        'regular': false,
        'reposicao': false,
        'aula': false,
        responseData: [],
        aulaAtual: null,

    }
    },
     mounted () {
       this.getTurmass();

     },

    methods: {

      getTurmass() {

        var id_turma =  null
        var id_agrupamento = null
        var data_inicio = null
        var data_fim = null
        var alunos_regulares = null
        var turma_virtual = null
        var turma_status = null

          var url = `${urlApi}/turmas/paginacao/${id_turma}/${id_agrupamento}/${data_inicio}/${data_fim}/${alunos_regulares}/${turma_virtual}/${turma_status}`
            this.cleanResultFilterRequisicao(url)
      },

      cleanResultFilterRequisicao (url) {
        this.table.data = ''
        this.table.from = ''
        this.table.currentPage = ''
        this.table.firstPageUrl = ''
        this.table.lastPage = ''
        this.table.lastPageUrl = ''
        this.table.nextPageUrl = ''
        this.table.path = ''
        this.table.perPage = ''
        this.table.prevPageUrl = ''
        this.table.to = ''
        this.table.total = ''
        this.table.pages = []
        this.table.resultForm = []
        this.table.resultsFilter = []

        this.$http.get(url).then((res) => {
          let responseData = res.data.dados


        this.table.data = responseData.turmas_teoricas.data
        this.table.from = responseData.turmas_teoricas.from

        this.table.currentPage = responseData.turmas_teoricas.current_page
        this.table.firstPageUrl = responseData.turmas_teoricas.first_page_url
        this.table.lastPage = responseData.turmas_teoricas.last_page
        this.table.lastPageUrl = responseData.turmas_teoricas.last_page_url
        this.table.nextPageUrl = responseData.turmas_teoricas.next_page_url
        this.table.path = responseData.turmas_teoricas.path
        this.table.perPage = responseData.turmas_teoricas.per_page
        this.table.prevPageUrl = responseData.turmas_teoricas.prev_page_url
        this.table.to = responseData.turmas_teoricas.to
        this.table.total = responseData.turmas_teoricas.total

        for (let i = 1; i <= (responseData.turmas_teoricas.last_page); i++) {
          this.table.pages.push(i)
        }

        this.items = this.table.data
        this.table.resultForm = responseData.filtros
        this.table.resultsFilter = responseData.turmas_teoricas.data
        this.table.data_atual = responseData.data_atual

        this.table.load = false
      })
    },

       registrarPresenca (turma) {

      this.aulaAtual = turma

      var ini = turma.data_inicio.split(/[- :]/)
      var end = turma.data_fim.split(/[- :]/)

      var ini_date = new Date(new Date(ini[0], ini[1] - 1, ini[2], ini[3], ini[4], ini[5]).getTime() - 30 * 60000)
      var end_date = new Date(new Date(end[0], end[1] - 1, end[2], end[3], end[4], end[5]).getTime() + 60 * 60000)
      var tolerancia = new Date(new Date(ini[0], ini[1] - 1, ini[2], ini[3], ini[4], ini[5]).getTime() + 15 * 60000)
      let now = new Date()
      let localTime = now.getTime()
      let localOffset = now.getTimezoneOffset() * 60000
      let utc = localTime + localOffset
      let offset = -3
      let fortaleza = utc + (3600000 * offset)
      let nowUtc = new Date(fortaleza)
      if (now.getTime() != nowUtc.getTime()) {
        console.log('HORA LOCAL: ' + now)
        console.log('HORA DE FORTALEZA: ' + nowUtc)
        now = nowUtc
      }

      if (ini_date > now || end_date < now) {
        PresencaController.launchToast('fa-times', 'Essa aula não está disponível!')
      } else {
        var presencaLogin
        if (tolerancia < now) {
          this.$http.get(urlApi + '/turmas/presenca/aluno/' + turma.id_turma_teorica).then((response) => {
            presencaLogin = response.body.dados
            if (presencaLogin === true) {
              var saida = new Date(new Date(end_date).getTime() - (60 * 60000))
              this.turma = turma
              this.$http.get(urlApi + '/ead/intervalo/' + turma.id_turma_teorica).then((response) => {
                console.log(response.body.intervalo)
                if(response.body.intervalo)
                {
                  const agora = new Date();
                  const intervalo_inicio = new Date(response.body.intervalo.inicio);
                  const intervalo_fim = new Date(response.body.intervalo.fim);
                  if(agora >= intervalo_inicio && agora <= intervalo_fim)
                  {
                    this.processPhoto()
                  }else
                  {
                    if(now > saida)
                    {
                      this.processPhoto()
                    }else
                    {
                      let button = document.getElementById('push_' + this.turma.id_agrupamento)
                      button.title = 'Entrar na sala!'
                      button.disabled = false
                    }
                  }
                }else
                {
                  if(now > saida)
                  {
                    this.processPhoto()
                  }else
                  {
                    console.log(now +' > '+ saida);
                    this.turma = turma
                    let button = document.getElementById('push_' + this.turma.id_agrupamento)
                    button.title = 'Entrar na sala!'
                    button.disabled = false
                  }

                }
              })
            } else {
              PresencaController.launchToast('fa-times', 'Essa aula não está disponível!')
            }
          }).catch((erro) => {
            if (erro.body.dados === false) {
              PresencaController.launchToast('fa-times', 'Você está atrasado para esta aula! Contate sua AutoEscola!')
            } else if (erro.body.dados === null) {
              PresencaController.launchToast('fa-times', 'ERRO: ' + erro.body.mensagem)
              console.log(erro.body.mensagem)
            }
          })

        }else {
          this.turma = turma
          this.processPhoto()
        }
      }
    },

      detalhes: function (idTurma) {
      let self = this
      this.statusModal = true
      this.$refs.smallModal.open()
      self.modal.load = true
      TurmasController.getTurmaById(idTurma, function (response) {
        self.modal.conteudo = response.data.dados
        self.modal.load = false
      })
    },

      modalClosed (eventClose) {
        this.stream.getTracks().forEach(function (track) {
        track.stop()
      })
    },

      push (dados) {
      let instrutor = this.id_role == 3 ? true : false;
      let data = {
        sala: dados.id_agrupamento, instrutor: instrutor, nome: localStorage.nome, id_aluno: localStorage.id, turma_teorica: dados.id_turma_teorica
        };
      this.$http.post(urlApi + '/ead/meet', data).then( response => {
        console.log(response.body.link);
        let agrupamento = {
          agrupamento:  dados.id_agrupamento,
          instrutor:    instrutor
        }
        window.sessionStorage['agrupamento'] = JSON.stringify(agrupamento);
        window.sessionStorage['intervalo'] = false
        window.sessionStorage['saida'] = false
        router.push({ path: '/ead/' + btoa(btoa(response.body.link))})
      })
    },

      ead (turma) {
      var ini = turma.data_inicio.split(/[- :]/)
      var end = turma.data_fim.split(/[- :]/)

      var ini_date = new Date(new Date(ini[0], ini[1] - 1, ini[2], ini[3], ini[4], ini[5]))
      var end_date = new Date(new Date(end[0], end[1] - 1, end[2], end[3], end[4], end[5]))

      if (this.id_role == 3) {
        this.$router.push({ name: 'eadAluno',
          params: {
            'ini': ini_date.getTime(),
            'end': end_date.getTime(),
            'turma': turma.id_turma_teorica
          } })
      } else if (this.id_role == 4) {
        this.$router.push({ name: 'eadInstrutor',
          params: {
            'ini': ini_date.getTime(),
            'end': end_date.getTime(),
            'turma': turma.id_turma_teorica
          } })
      }
    },

     getTime (data_fim) {
      let end = data_fim.split(/[- :]/)
      let end_date = new Date(new Date(end[0], end[1] - 1, end[2], end[3], end[4], end[5]))
      let check = ((end_date.getTime() - new Date().getTime()) > 0)
      return true
     },

       processPhoto () {
      let self = this
      self.presenca = false
      navigator.mediaDevices.getUserMedia({ video: { width: 250, height: 250 } })
        .then(function (stream) {
          self.stream = stream
          document.getElementById('player').srcObject = stream
          self.$refs.photoModal.open()
        }).catch(function (err) {
          if (err.name == 'AbortError') {
            // declarações para manipular exceções AbortError
            PresencaController.launchToast('fa-times', err)
            PresencaController.launchToast('fa-times', 'Operação Interrompida!'.toUpperCase())
          } else if (err.name == 'NotAllowedError') {
            // declarações para manipular exceções NotAllowedError
            PresencaController.launchToast('fa-times', err)
            PresencaController.launchToast('fa-times', 'Não foi possível acessar sua câmera! Cheque as permissões do sistema.'.toUpperCase())
          } else if (err.name == 'NotFoundError') {
            // declarações para manipular exceções NotFoundError
            PresencaController.launchToast('fa-times', err)
            PresencaController.launchToast('fa-times', 'Nenhuma câmera encontrada!'.toUpperCase())
          } else if (err.name == 'NotReadableError') {
            // declarações para manipular exceções NotReadableError
            PresencaController.launchToast('fa-times', err)
            PresencaController.launchToast('fa-times', 'Não foi possível acessar sua câmera!'.toUpperCase())
          } else if (err.name == 'OverconstrainedError') {
            // declarações para manipular exceções OverconstrainedError
            PresencaController.launchToast('fa-times', err)
            PresencaController.launchToast('fa-times', 'Dispositivo inválido!'.toUpperCase())
          } else if (err.name == 'SecurityError') {
            // declarações para manipular exceções SecurityError
            PresencaController.launchToast('fa-times', err)
            PresencaController.launchToast('fa-times', 'O sistema não possui permissão para acessar sua câmera! Cheque as permissões do sistema.'.toUpperCase())
          } else if (err.name == 'TypeError') {
            // declarações para manipular exceções TypeError
            PresencaController.launchToast('fa-times', err)
            PresencaController.launchToast('fa-times', 'Erro desconhecido!'.toUpperCase())
          } else {
            // declarações para manipular quaisquer exceções não especificadas
            PresencaController.launchToast('fa-times', err)
            PresencaController.launchToast('fa-times', 'Erro desconhecido!'.toUpperCase())
          }

          console.log(err)
        })
    },

      ativar (opcao) {
      if (opcao == 'Alunos Regulares') {
        this.regular = true
      } else if (opcao == 'Alunos Reposição') {
        this.reposicao = true
      } else if (opcao == 'Aulas') {
        this.aula = true
      } else if ('Presenças') {
        this.historico = true
      }
    },

     captureSnapshot () {
      let self = this

      var snapshotCanvas = document.getElementById('snapshot')
      snapshotCanvas
        .getContext('2d')
        .drawImage(document.getElementById('player'), 0, 0, 250, 250)
      document.getElementById('send').disabled = false
    },
      sendSnapshot () {
      let self = this

      self.$refs.photoModal.close()

      var data = {
        foto: document.getElementById('snapshot').toDataURL('image/jpeg'),
        cpf: localStorage.cpf
      }

      PresencaController.sendSnapshot(data, function (response) {
        var size = response.data.dados[1]
        var conf = response.data.dados[2]

        console.log('Confiança: ' + conf ** 2 / size)

        if ((conf ** 2 / size) > 70) {
          PresencaController.launchToast('fa-times', 'Foto inválida!')
          self.$refs.photoModal.open()
        } else {
          let role = ''

          if (self.id_role == 4) {
            role = 'ALUNO'
          } else if (self.id_role == 3) {
            role = 'INSTRUTOR'
          }

          let data = {
            entidade: role,
            id: localStorage.id,
            turma: self.turma.id_turma_teorica,
            dispositivo: 'navegador'

          }

          self.$http.post(urlApi + '/ead/presenca', data).then(function (response) {
            console.log()
            PresencaController.launchToast('fa-check', 'Sucesso!')

            let button = document.getElementById('push_' + self.turma.id_agrupamento)
            button.title = 'Entrar na sala!'
            button.disabled = false
            self.push(this.aulaAtual);
            self.modalClosed()
          }).catch(function (error) {
            console.log(error.body.mensagem)
            PresencaController.launchToast('fa-check', error.body.mensagem)
            console.log(error)
          })
        }
      })
    },
  },
}
</script>

<style scoped>

 .table-hover  th:hover td:hover {
    background-color: rgba(255, 194, 14, 0.5);
 }
 .btn-turma:hover {
  background-color: aqua;
 }
</style>
